import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { verifyLogin } from "../utilities/authHelper";
import LoadingOverlay from "../Dashboard/Common/LoadingOverlay";
import NavBarComponent from "../Dashboard/Common/navbar";
import {
  validatePassword,
  validatePhoneNumber,
} from "../utilities/CommonUtilities";
import { Button } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Assuming you're using react-icons for the eye icons

function Signup() {
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [first_name, set_first_name] = useState("");
  const [last_name, set_last_name] = useState("");
  const [phone_number, set_phone_number] = useState("");
  const [role, setRole] = useState("USER");
  const [passwordShown, setPasswordShown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [errorMessage, setErrorMessage] = useState([]);
  const navigate = useNavigate();
  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown);
  };
  useEffect(() => {
    if (verifyLogin()) {
      navigate("/dashboard");
    }
  }, [navigate]);

const getQueryParams = (query) => {
  return new URLSearchParams(query);
};
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validatePhoneNumber(phone_number)) {
      setErrorMessage([
        `Invalid phone number.`,
        `Format should be: '+(country code)-(10 digit number)'  e.g. +91-1234567890'.`,
      ]);
      return;
    }
    const passwordError = validatePassword(password);
    if (passwordError.length > 0) {
      setErrorMessage(passwordError);
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage(["Passwords don't match."]);
      return;
    }
    try {
      setIsLoading(true);
      const response = await fetch(`${apiUrl}/auth:sign_up`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
          first_name,
          last_name,
          role,
          phone_number,
          invitationCode: getQueryParams(location.search).get("invitationCode"),
        }),
      });
      if (!response.ok) {
        const data = await response.json();
        setErrorMessage([`Reason: ${data.detail}`]);
      } else {
        const data = await response.json();
        console.log("Signup successful:", data);
        navigate("/confirm-email");
      }
    } catch (error) {
      setErrorMessage(["Signup failed. Please try again."]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="row" style={{ height: "100%" }}>
        {isLoading ? (
          <LoadingOverlay />
        ) : (
          <>
            <NavBarComponent isUserLoggedIn={verifyLogin()} />
            <div
              className="container bg-white "
              style={{ height: "90%", width: "auto" }}
            >
              <div className="row d-flex justify-content-center align-items-center   h-100">
                <div className="col-lg-12 col-xl-11">
                  <div className="card text-black">
                    <div className="card-body p-md-3 shadow ">
                      <div className="row justify-content-center">
                        <div className="col-md-10 col-lg-6 col-xl-5 order-2 order-lg-1">
                          <p className="text-center h1 fw-bold mb-5 mx-1 mx-md-4 mt-4">
                            Sign Up
                          </p>

                          <form
                            className="mx-1 mx-md-4"
                            onSubmit={handleSubmit}
                          >
                            <div className="d-flex flex-row align-items-center mb-2">
                              <div className="form-floating  mb-3 pe-2">
                                <input
                                  type="text"
                                  id="firstName"
                                  className="form-control"
                                  placeholder="First Name"
                                  value={first_name}
                                  onChange={(e) =>
                                    set_first_name(e.target.value)
                                  }
                                  required
                                />
                                <label htmlFor="firstName" className="">
                                  <i className="fas fa-user fa-lg me-3 fa-fw" />
                                  First Name
                                </label>
                              </div>

                              <div className="form-floating flex-fill mb-3">
                                <input
                                  type="text"
                                  id="lastName"
                                  className="form-control"
                                  value={last_name}
                                  onChange={(e) =>
                                    set_last_name(e.target.value)
                                  }
                                  required
                                  placeholder="Last Name"
                                />
                                <label
                                  className="form-label"
                                  htmlFor="lastName"
                                >
                                  Last Name
                                </label>
                              </div>
                            </div>
                            <div className="d-flex flex-row align-items-centermb-2">
                              <div className="form-floating flex-fill mb-3">
                                <input
                                  type="email"
                                  value={email}
                                  id="form3Example3c"
                                  className="form-control"
                                  onChange={(e) => setEmail(e.target.value)}
                                  required
                                  placeholder="Your Email"
                                />
                                <label
                                  className="form-label"
                                  htmlFor="form3Example3c"
                                >
                                  <i className="fas fa-envelope fa-lg me-3 fa-fw" />
                                  Your Email
                                </label>
                              </div>
                            </div>
                            <div className="d-flex flex-row align-items-centermb-2">
                              <div className="form-floating flex-fill mb-3">
                                <input
                                  type="text"
                                  id="phoneNumber"
                                  className="form-control"
                                  value={phone_number}
                                  onChange={(e) =>
                                    set_phone_number(e.target.value)
                                  }
                                  required
                                  placeholder="Phone Number"
                                />
                                <label
                                  className="form-label"
                                  htmlFor="phoneNumber"
                                >
                                  <i className="fa-solid fa-phone fa-lg me-3 fa-fw" />
                                  Phone Number
                                </label>
                              </div>
                            </div>
                            <div className="d-flex flex-row align-items-centermb-2">
                              <div className="form-floating flex-fill mb-3">
                                <input
                                  type={passwordShown ? "text" : "password"}
                                  value={password}
                                  id="form3Example4c"
                                  className="form-control"
                                  onChange={(e) => setPassword(e.target.value)}
                                  required
                                  placeholder="Password"
                                />
                                <label
                                  className="form-label"
                                  htmlFor="form3Example4c"
                                >
                                  <i className="fas fa-lock fa-lg me-3 fa-fw" />
                                  Password
                                </label>
                                <Button
                                  variant="outline-secondary"
                                  className="position-absolute end-0 top-50 translate-middle-y me-2"
                                  onClick={togglePasswordVisibility}
                                  style={{
                                    border: "none",
                                    background: "none",
                                    color: "inherit",
                                  }}
                                >
                                  {passwordShown ? <FaEyeSlash /> : <FaEye />}
                                </Button>
                              </div>
                            </div>

                            <div className="d-flex flex-row align-items-center mb-2">
                              <div className="form-floating flex-fill mb-2">
                                <input
                                  type="password"
                                  id="form3Example4cd"
                                  className="form-control"
                                  value={confirmPassword}
                                  onChange={(e) =>
                                    setConfirmPassword(e.target.value)
                                  }
                                  required
                                  placeholder="Confirm Your Password"
                                />
                                <label
                                  className="form-label"
                                  htmlFor="form3Example4cd"
                                >
                                  <i className="fas fa-key fa-lg me-3 fa-fw" />
                                  Confirm your password
                                </label>
                              </div>
                            </div>
                            {errorMessage.length > 0 && (
                              <div className="alert alert-danger">
                                {errorMessage.map((msg, index) => (
                                  <React.Fragment key={index}>
                                    {msg}{" "}
                                    {index < errorMessage.length - 1 && <br />}
                                  </React.Fragment>
                                ))}
                              </div>
                            )}

                            <div className="d-flex justify-content-center mx-4 mb-3 mb-lg-4">
                              <button
                                type="submit"
                                className="btn btn-primary btn-lg"
                              >
                                Register
                              </button>
                            </div>
                            <p className="text-center text-muted mt-5 mb-3">
                              Have already an account?{" "}
                              <a href="/login" className="fw-bold text-body">
                                <u>Login here</u>
                              </a>
                            </p>
                          </form>
                        </div>
                        <div className="col-md-10 col-lg-6 col-xl-7 d-flex align-items-center order-1 order-lg-2">
                          <img
                            src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/draw1.webp"
                            className="img-fluid"
                            alt="Emalpha"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Signup;
